var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-block__splashscreen",class:{
    primary:
      _vm.$voicer.getConfig('enabledSplashScreen') ||
      _vm.$voicer.getConfig('enabledSplashScreen.mode') === 'classic',
  }},[_c('img',{attrs:{"src":require('~/assets/images/argedis_splashscreen.png'),"width":"512"}})])}
var staticRenderFns = []

export { render, staticRenderFns }